module.exports = __webpack_public_path__ + "static/img/9.dc4c94c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9.jpg
// module id = VyWw
// module chunks = 1